import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

function DonutTooltip({ active, payload }: any) {
  if (!active || !payload?.length) return null;
  const d = payload[0];
  return (
    <div className="bg-white border border-[#D9E2EC] rounded-lg px-3 py-2 shadow-lg text-[11px]">
      <div className="flex items-center gap-1.5"><div className="w-2 h-2 rounded-sm" style={{ background: d.payload.color }} /><span className="text-[#0B1F4A] font-semibold">{d.name}</span></div>
      <div className="text-[#3D4F6F] mt-0.5">€{(d.value / 1e3).toFixed(0)}k/jaar ({((d.value / d.payload.total) * 100).toFixed(1)}%)</div>
    </div>
  );
}

function Donut({ data, title, printMode }: { data: { name: string; value: number; color: string }[]; title: string; printMode?: boolean }) {
  const total = data.reduce((s, d) => s + d.value, 0);
  const enriched = data.map(d => ({ ...d, total }));
  return (
    <div className="flex-1 min-w-[250px]">
      <div className="text-[11px] font-semibold text-[#0B1F4A] mb-2 text-center">{title}</div>
      <ResponsiveContainer width="100%" height={200}>
        <PieChart><Pie data={enriched} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={50} outerRadius={80} paddingAngle={2} isAnimationActive={!printMode}>{enriched.map((d, i) => <Cell key={i} fill={d.color} />)}</Pie><Tooltip content={<DonutTooltip />} /></PieChart>
      </ResponsiveContainer>
      <div className="flex flex-wrap justify-center gap-2 mt-1">{data.map((d, i) => (<div key={i} className="flex items-center gap-1 text-[9px] text-[#3D4F6F]"><div className="w-2 h-2 rounded-sm" style={{ background: d.color }} />{d.name}</div>))}</div>
    </div>
  );
}

export default function CostRevenueDonut({ costStructure, revenueStructure, printMode }: { costStructure: { name: string; value: number; color: string }[]; revenueStructure: { name: string; value: number; color: string }[]; printMode?: boolean }) {
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] shadow-sm p-5 mb-4">
      <div className="text-sm font-bold text-[#0B1F4A] mb-1">⚖️ Kosten- en Opbrengstenstructuur (Jaar 1)</div>
      <div className="flex flex-wrap gap-4">
        <Donut data={costStructure} title="Kostenstructuur" printMode={printMode} />
        <Donut data={revenueStructure} title="Opbrengstenstructuur" printMode={printMode} />
      </div>
    </div>
  );
}
